import { render } from "./ConfigurationBusinesshours.vue?vue&type=template&id=05a45c24"
import script from "./ConfigurationBusinesshours.vue?vue&type=script&lang=js"
export * from "./ConfigurationBusinesshours.vue?vue&type=script&lang=js"

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/ConfigurationBusinesshours.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05a45c24"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05a45c24', __exports__)) {
    console.log('reload')
    api.reload('05a45c24', __exports__)
  }
  
  module.hot.accept("./ConfigurationBusinesshours.vue?vue&type=template&id=05a45c24", () => {
    console.log('re-render')
    api.rerender('05a45c24', render)
  })

}


export default __exports__